// fr-CA flag return value in format "YYYY-MM-DD" the same format is return from  BE
export const DAY_FORMAT = new Intl.DateTimeFormat("fr-CA", {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
});
